// =====================
// GATES CARD COLORS
// =====================

// Status Colors
export const GATES_STATUS_CLEARED = '#16A34A';
export const GATES_STATUS_REJECTED = '#EF4444';
export const GATES_STATUS_PENDING_COLOR = '#9CA3AF';
export const GATES_STATUS_NOTIFIED = '#3B82F6';
export const GATES_STATUS_WAITING = '#9CA3AF';

// Status Background Colors
export const GATES_STATUS_CLEARED_BG = '#DCFCE7';
export const GATES_STATUS_REJECTED_BG = '#FEE2E2';
export const GATES_STATUS_PENDING_BG = 'rgba(156, 163, 175, 0.1)';
export const GATES_STATUS_COMMENT_BG = '#fef2f2';
export const GATES_STATUS_COMMENT_BORDER = '#fecaca';

// Border Colors
export const GATES_BORDER_DEFAULT = '#d1d5db';
export const GATES_BORDER_LIGHT = '#e5e7eb';
export const GATES_BORDER_DIVIDER = '#f5f5f5';

// Approval Mode Badge Colors - Sequential
export const APPROVAL_MODE_SEQUENTIAL_BG = '#eff6ff';
export const APPROVAL_MODE_SEQUENTIAL_COLOR = '#1e40af';

// Approval Mode Badge Colors - Parallel
export const APPROVAL_MODE_PARALLEL_BG = '#fef9e7';
export const APPROVAL_MODE_PARALLEL_COLOR = '#b45309';

// Approval Mode Badge Colors - Auto Approve
export const APPROVAL_MODE_AUTO_APPROVE_BG = '#f0fdf4';
export const APPROVAL_MODE_AUTO_APPROVE_COLOR = '#15803d';

// Approval Mode Badge Colors - Exclusive
export const APPROVAL_MODE_EXCLUSIVE_BG = '#fef2f2';
export const APPROVAL_MODE_EXCLUSIVE_COLOR = '#dc2626';

// Approval Mode Badge Colors - Default
export const APPROVAL_MODE_DEFAULT_BG = '#f3f4f6';
export const APPROVAL_MODE_DEFAULT_COLOR = '#6b7280';

// Container Colors
export const GATES_SUMMARY_HEADER_BG = '#f9fafb';
export const GATES_SUMMARY_HEADER_COLOR = '#374151';
export const GATES_SUMMARY_HEADER_REJECTED_BG = '#fef2f2';
export const GATES_SUMMARY_HEADER_REJECTED_COLOR = '#991b1b';
